export const getPayloadInfo = action => action?.payload?.info;

// below helpers are for: https://jsonapi.org/examples/#pagination
// NOT to be confused with action.meta which is for flux standard actions
export const getPayloadData = action => getPayloadInfo(action)?.data;

export const getPayloadMeta = action => getPayloadInfo(action)?.meta;
